import { Button, PulseAnimation } from '@/components';

type Props = {
	onStopSearchUser: () => void;
	waitingStudent?: number;
};

const InstantMeetingsSearchingState = ({ onStopSearchUser, waitingStudent }: Props) => {
	return (
		<div className={'coach-instant-meetings-container'}>
			<div className={'instant-meetings-info-container'}>
				<h1>Öğrenci Aranıyor!</h1>
				<p>Birazdan görüşme yapacağın uygun bir öğrenci tarafına atanacak. Lütfen beklemeye devam edin.</p>
			</div>

			<div className={'instant-meetings-actions-container'}>
				<PulseAnimation
					isActive
					size={225}
					className={'pulse-animation'}
					color={'var(--text-3a68bc)'}>
					<i className={'icons-user-circle'}></i>
				</PulseAnimation>

				<div className={'waiting-user-container'}>
					<p className={'waiting-student-text'}>
						Şu an görüşme bekleyen <b>{waitingStudent} öğrenci</b>
						<br />
						bulunmaktadır.
					</p>
				</div>

				<Button
					variant={'danger'}
					onClick={onStopSearchUser}>
					Aramayı Durdur
				</Button>
			</div>
		</div>
	);
};

export default InstantMeetingsSearchingState;
